import React from 'react';

import GrupoIncentivo from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/GrupoIncentivo/List.js';

export default function () {
  return <GrupoIncentivo />;
}
